module.exports = __webpack_public_path__ + "img/page智慧农业.4afdb64f.png";